import { useCallback, useState } from 'react';

export function useForceRefresh() {
  const setVal = useState(0)[1];

  return useCallback(() => {
    setVal(old => old + 1);
  }, [setVal]);
}
